import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import LocalOffer from '@material-ui/icons/LocalOffer';
import { connect } from 'react-redux';
import FormatListNumbered from '@material-ui/icons/FormatListNumbered';
import { getCategory as getCategoryList } from '../../store/actions/admin/Admin';
// core components
import GridItem from '../../components/Grid/GridItem.js';
import Card from '../../components/Card/Card.js';
import CardHeader from '../../components/Card/CardHeader.js';
import CardIcon from '../../components/Card/CardIcon.js';
import CardFooter from '../../components/Card/CardFooter.js';

import styles from '../../assets/jss/material-dashboard-react/views/dashboardStyle.js';

const useStyles = makeStyles(styles);

var update = false;
function SuperCategoriesAdmin(props) {
  useEffect(() => {
    props.getCategoryList();
  }, [update]);

  const classes = useStyles();
  return (
    <GridItem xs={12} sm={6} md={3}>
      <Link style={{ textDecoration: 'none' }} to={'/admin/super-categories'}>
        <Card>
          <CardHeader color="success" stats icon>
            <CardIcon color="success">
              <FormatListNumbered />
            </CardIcon>
            <p className={classes.cardCategory}>Super-Categories</p>
            <h3 className={classes.cardTitle}>
              {props.superCategories.length}
            </h3>
          </CardHeader>
          <CardFooter stats>
            <div className={classes.stats}>
              <LocalOffer />
              List of superCategories added
            </div>
          </CardFooter>
        </Card>
      </Link>
    </GridItem>
  );
}

const mapStateWithProps = (state) => ({
  superCategories: state.admin.superCategories
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList())
  };
};

export default connect(
  mapStateWithProps,
  mapDispatchWithProps
)(SuperCategoriesAdmin);
